import { render, staticRenderFns } from "./GetOrdersByUser.vue?vue&type=template&id=41eaafee&scoped=true"
import script from "./GetOrdersByUser.vue?vue&type=script&lang=js"
export * from "./GetOrdersByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eaafee",
  null
  
)

export default component.exports